import { createContext, useContext, useState, ReactNode } from 'react';
import { Spinner } from '@/shared/ui/Spinner/Spinner';

interface SpinnerContextType {
    showSpinner: () => void;
    hideSpinner: () => void;
}

const SpinnerContext = createContext<SpinnerContextType | undefined>(undefined);

export const SpinnerProvider = ({ children }: { children: ReactNode }) => {
    const [isLoading, setIsLoading] = useState(false);

    const showSpinner = () => setIsLoading(true);
    const hideSpinner = () => setIsLoading(false);

    return (
        <SpinnerContext.Provider value={{ showSpinner, hideSpinner }}>
            {children}
            {isLoading && <Spinner />}
        </SpinnerContext.Provider>
    );
};

export const useSpinner = () => {
    const context = useContext(SpinnerContext);
    if (context === undefined) {
        throw new Error('useSpinner must be used within a SpinnerProvider');
    }
    return context;
}; 